<template>
  <div>
    <div class="trade-order-block">
      <div class="block-content">
        <el-row class="content-row">
          <el-col :span="3">申请验收时间</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.applyAcceptanceTime | parseTime('{y}-{m}-{d}') }}</el-col>
          <el-col :span="3">供应商实际产生费用</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.actualAmount  | thousandSymbol}}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">完工信息</el-col>
          <el-col :span="21" class="detail-file" v-viewer="{movable: true}">
            <div v-for="(item, index) in acceptanceList" :key="index" class="detail-file-content">
              <img v-if="item.acceptanceCode[0] === 'I'" :src="getImg(item.fileUri)" />
              <div v-else>
                <a class="icon-download" :href="getFile(item.fileUri)"> {{ item.acceptanceName + '' }}</a>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 费用明细 -->
      <div v-if="tradeApplyInfoVO.tradeApplyAcceptanceVO">
        <div class="block-title block-sub-title" v-if="itemDetailList.length">费用明细</div>
        <div class="block-content" v-if="itemDetailList.length">
          <!-- 高端店招 -->
          <div class="block-content-title" v-if="shopList.length">高端店招</div>
          <div class="block-content-table" v-if="shopList.length">
            <el-row class="table-title">
              <el-col :span="6">物料名称</el-col>
              <el-col :span="6">数量</el-col>
              <el-col :span="6">单价</el-col>
              <el-col :span="6">总价</el-col>
            </el-row>
            <el-row class="table-row" v-for="(item, index) in shopShowList" :key="index">
              <el-col :span="6">{{ item.itemName }}</el-col>
              <el-col :span="6">{{ item.itemQty  | thousandSymbol }}</el-col>
              <el-col :span="6">{{ item.itemPrice  | thousandSymbol }}</el-col>
              <el-col :span="6">{{ item.itemSum  | thousandSymbol }}</el-col>
            </el-row>
            <div class="table-row-more" v-show="shopList.length > 3" @click="handleTable(0)">
              <i :class="[ shopShowList === shopList ? 'el-icon-arrow-up' : 'el-icon-arrow-down']" />
              {{ shopShowList === shopList ? '收起' : '查看更多' }}
            </div>
          </div>
          <!-- 物料定制 -->
          <div class="block-content-title" v-if="materialList.length">物料定制</div>
          <div class="block-content-table" v-if="materialList.length">
            <el-row class="table-title">
              <el-col :span="6">物料名称</el-col>
              <el-col :span="6">数量</el-col>
              <el-col :span="6">单价</el-col>
              <el-col :span="6">总价</el-col>
            </el-row>
            <el-row class="table-row" v-for="(item, index) in materialShowList" :key="index">
              <el-col :span="6">{{ item.itemName }}</el-col>
              <el-col :span="6">{{ item.itemQty  | thousandSymbol }}</el-col>
              <el-col :span="6">{{ item.itemPrice  | thousandSymbol }}</el-col>
              <el-col :span="6">{{ item.itemSum  | thousandSymbol }}</el-col>
            </el-row>
            <div class="table-row-more" v-show="materialList.length > 3" @click="handleTable(1)">
              <i :class="[ materialShowList === materialList ? 'el-icon-arrow-up' : 'el-icon-arrow-down']" />
              {{ materialShowList === materialList ? '收起' : '查看更多' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'

export default {
  name: 'order-accept-info',
  data () {
    return {
      tradeApplyOrderVO: '',
      tradeApplyInfoVO: '',
      acceptanceList: [],
      itemDetailList: [],
      shopList: [],
      shopShowList: [],
      materialList: [],
      materialShowList: []
    }
  },
  created () {

  },
  methods: {
    setAcceptInfo (info) {
      this.tradeApplyOrderVO = info
      this.tradeApplyInfoVO = info.tradeApplyInfoVO
      if (this.tradeApplyInfoVO.tradeApplyAcceptanceVO) {
        this.acceptanceList = this.tradeApplyInfoVO.tradeApplyAcceptanceVO.acceptanceList || []
        this.itemDetailList = this.tradeApplyInfoVO.tradeApplyAcceptanceVO.itemDetailList || []
      }

      this.shopList = []
      this.materialList = []

      // 费用明细
      if (this.itemDetailList.length) {
        this.itemDetailList.forEach((item) => {
          if (item.applyStatus === '02') {
            if (item.itemType === 'shopsign') {
              this.shopList.push(item)
            } else {
              this.materialList.push(item)
            }
          }
        })
      }
      this.shopShowList = this.shopList.slice(0, 3)
      this.materialShowList = this.materialList.slice(0, 3)
    },

    handleTable (val) {
      if (!val) {
        if (this.shopShowList.length === 3) {
          this.shopShowList = this.shopList
        } else {
          this.shopShowList = this.shopList.slice(0, 3)
        }
      } else if (val === 1) {
        if (this.materialShowList.length === 3) {
          this.materialShowList = this.materialList
        } else {
          this.materialShowList = this.materialList.slice(0, 3)
        }
      }
    },

    getFile (uri) {
      return commonUtils.getFileUrl(uri)
    },

    getImg (uri) {
      return commonUtils.getImageUrl(uri)
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-file {
  display: flex;
  align-items: center;

  .detail-file-content {
    width: 100px;
    height: 120px;
    margin-right: 20px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
      border-radius: 4px;
    }
  }
}

.block-content-title {
  color: $base-red;
  padding: 15px 0 5px 5px;
}

.block-content-table {
  .el-row {
    line-height: 40px;
    text-align: center;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }

  .table-title {
    font-weight: bold;
    background-color: #ebf4ff;
  }

  .table-row-more {
    color: $base-blue;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 8px;
    cursor: pointer;

    .el-icon-arrow-down,
    .el-icon-arrow-up {
      font-weight: bold;
      font-size: 18px;
      padding-right: 2px;
    }
  }
}
.icon-download {
  color: $base-blue;

  &:hover {
    opacity: 0.5;
  }
}

</style>
